import inactiveEye from '../images/icons/icon_eye.svg'
import activeEye from '../images/icons/icon_eye_active.svg'

$(() => {
  const form = $('#vr-managed-form, .vr-managed-form')

  if (form.length === 0) {
    return
  }

  const eyeIcon = $('.vr-textfield__icon.eye, .modal_eye')
  const eyeIconSrc = {
    inactive: inactiveEye,
    active: activeEye,
  }

  // For Password field, display typed password on eye click
  eyeIcon.click(() => {
    const field = eyeIcon.closest(':has(div)').find('.vr-textfield')
    const isInTextMode = field.attr('type') === 'text'

    // Update field and icon view
    if (!isInTextMode) {
      field.attr('type', 'text')
      eyeIcon.attr('src', eyeIconSrc.active)
    } else {
      field.attr('type', 'password')
      eyeIcon.attr('src', eyeIconSrc.inactive)
    }
  })
})
